import {
  Button,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
} from '@chakra-ui/react';
import { CloseCircleOutline } from '@aslanpay/portal-common-lib';

import { UnassignPotManagerModalProps } from './UnassignPotManagerModal.types';

function UnassignPotManagerModal({
  isOpen,
  onClose,
  firstName,
  lastName,
  potName,
  action,
  isLoading,
  onConfirm,
}: UnassignPotManagerModalProps) {
  const fullName = `${firstName} ${lastName}`;

  const title =
    action === 'unassign-manager'
      ? `Unassign ${fullName} as a pot manager?`
      : `Remove ${fullName} from ${potName} Pot?`;

  const body =
    action === 'unassign-manager' ? (
      <Text textStyle="smallMedium" textColor="brand.darkGray">
        If you continue, {fullName} will no longer have manager permissions for {potName} Pot. They
        can still be added as a pot manager in the future.
      </Text>
    ) : (
      <Text textStyle="smallMedium" textColor="brand.darkGray">
        If you continue, {fullName} will be removed from {potName} Pot and will lose all manager
        permissions. They can still be added back in the future.
      </Text>
    );

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent w={{ base: '100vw', sm: '560px' }} maxW={{ base: '100vw', sm: '560px' }}>
        <ModalHeader>
          <HStack>
            <Text textStyle="h4" fontSize="18px" fontWeight="600">
              {title}
            </Text>
            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close modal"
              onClick={onClose}
              isDisabled={isLoading}
            />
          </HStack>
        </ModalHeader>
        <ModalBody>{body}</ModalBody>
        <ModalFooter gap="12px">
          <Button variant="outline" onClick={onClose} isDisabled={isLoading}>
            Cancel
          </Button>
          <Button onClick={onConfirm} isLoading={isLoading}>
            Yes, confirm
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default UnassignPotManagerModal;
